import { render, staticRenderFns } from "./mstrbudget.vue?vue&type=template&id=ed152056"
import script from "./mstrbudget.vue?vue&type=script&lang=js"
export * from "./mstrbudget.vue?vue&type=script&lang=js"
import style0 from "./mstrbudget.vue?vue&type=style&index=0&id=ed152056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports